// API Configuration
// In development: use proxy (configured in package.json)
// In production: use full backend URL

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Helper function to build full API URL
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  
  if (API_BASE_URL) {
    return `${API_BASE_URL}/${cleanEndpoint}`;
  }
  
  // In development with proxy, just return the endpoint
  return `/${cleanEndpoint}`;
};

// Helper function to get headers for API requests
// Includes ngrok-skip-browser-warning header when using ngrok in production
export const getApiHeaders = (additionalHeaders = {}) => {
  const headers = {
    ...additionalHeaders
  };
  
  // Add ngrok header if using ngrok URL
  if (API_BASE_URL && API_BASE_URL.includes('ngrok')) {
    headers['ngrok-skip-browser-warning'] = 'true';
  }
  
  return headers;
};

export default API_BASE_URL;
